var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82851 5.18273V3.07995C5.82851 2.851 6.01437 2.66428 6.24417 2.6626H7.19799C7.42694 2.66513 7.61196 2.85099 7.61281 3.07995V4.16132L5.82853 5.19117L5.82851 5.18273ZM20.4228 10.2652C20.3434 10.2323 20.2665 10.1951 20.1913 10.1529L12.4054 5.66253C12.2956 5.59579 12.157 5.59579 12.0463 5.66253L4.2604 10.1529C4.18606 10.1951 4.10918 10.2331 4.02892 10.2652V20.6854C4.02301 21.1838 4.42176 21.5927 4.92022 21.6003H8.59691V15.9054C8.59944 14.944 9.37838 14.165 10.3398 14.1625H14.101C15.0633 14.165 15.8431 14.9431 15.8465 15.9054V21.6003H19.5231C19.7622 21.597 19.9903 21.4981 20.1576 21.3266C20.324 21.1551 20.4153 20.9245 20.4119 20.6854V10.2652L20.4228 10.2652ZM11.586 4.92082L11.608 4.90815C11.9881 4.68342 12.4604 4.68342 12.8406 4.90815L20.6265 9.39847V9.39762C21.054 9.64009 21.5972 9.49478 21.8464 9.07152C22.088 8.64319 21.9419 8.09997 21.5178 7.8516L12.8127 2.83162C12.4562 2.61957 12.0135 2.61957 11.6569 2.83162L8.29364 4.7781H8.29448C8.27674 4.78993 8.259 4.80091 8.24041 4.8102L5.6451 6.32414L5.59103 6.35455L2.95852 7.86848C2.54626 8.12193 2.41022 8.65754 2.65269 9.07657C2.89431 9.49561 3.42654 9.64599 3.8515 9.41535L11.586 4.92082Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.a274a5cab466206f3b8790408708deb8.svg";
export { ForwardRef as ReactComponent };